import React from "react";

import { AtSymbolIcon, IdentificationIcon, PhoneIcon, UserIcon } from "@heroicons/react/24/solid";

const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
}

const ResumenAlumno = ({
    datosInscripcion = {},
    color = "bg-primarioMira",
    carnet = '',
    row=true
}) => {

    const showTel = () => {
        if(datosInscripcion.DialCode){
            return `${datosInscripcion["DialCode"]} ${datosInscripcion["Cel"].split(datosInscripcion["DialCode"])[1]}`
        }else{
            return `${datosInscripcion["Cel"]}`
        }
    }


    return (        
        <>
            <div className={classNames(row ? `md:flex-row`: `md:flex-col`,  `flex flex-col  justify-between ${color} rounded-md p-2 m-2 text-center gap-2 elementFadeIn`)}>
                {carnet !== '' ? (
                    <div className="flex flex-row gap-2">
                        {/* <p className="inline text-base text-white">
                            Carnet:{" "}
                        </p> */}
                        <IdentificationIcon className="w-6 h-6 text-gray-400"></IdentificationIcon>
                        <p className="inline text-base text-white">
                            {carnet}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion.Nombres !== undefined ? (
                    <div className="flex flex-row gap-2">
                        {/* <p className="inline text-base text-white">
                            Nombre completo:{" "}
                        </p> */}
                        <UserIcon className="w-6 h-6 text-gray-400"></UserIcon>
                        <p className="inline text-base text-white">
                            {datosInscripcion.Nombres} {datosInscripcion.Apellidos}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion.Email !== undefined ? (
                    <div className="flex flex-row gap-2">
                        {/* <p className="inline text-base text-white">
                            Email:{" "}
                        </p> */}
                        <AtSymbolIcon className="w-6 h-6 text-gray-400"></AtSymbolIcon>
                        <p className="inline text-base text-white">
                            {datosInscripcion.Email}
                        </p>
                    </div>
                ) : null}
                {datosInscripcion?.Celular !== undefined ? (
                    <div className="flex flex-row gap-2">
                        {/* <p className="inline text-base text-white">
                            Celular:{" "}
                        </p> */}
                        <p className="inline text-base text-white">
                            {datosInscripcion.Celular}
                        </p>
                    </div>
                ) : 
                

                <div className="flex flex-row gap-2">
                  <PhoneIcon className="w-6 h-6 text-gray-400"></PhoneIcon>
                  <p className="inline text-base text-white">
                  {showTel()}
                  </p>
                </div>}
            </div>
        </>
    );
};

export default ResumenAlumno;
